import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import TransacaoNotaFiscalService from "service/fiscal/TransacaoNotaFiscalService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const transacaoNotaFiscalService = new TransacaoNotaFiscalService();

export default function TransacaoNotaFiscalListagem() {
    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        descricao: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        naturezaOperacao: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="codigoInterno,ASC" service={transacaoNotaFiscalService} urlService="/transacaoNotaFiscal"
            tituloPagina="Transações de nota fiscal" defaultFilters={defaultFilters} showClearFilterButton nome="transacaoNotaFiscal">
            <Column field="codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="naturezaOperacao" header="Natureza da operação" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="tipoOperacao" header="Tipo" body={(rowData) => transacaoNotaFiscalService.getTipoOperacao(rowData.tipoOperacao)} />
            <Column field="ativa" header="Ativo" body={(rowData) => rowData.ativa ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
